import ct from "class-types.macro";
import React from "react";

export interface CartAndQuantityProps {
  isCompareWithProductBox: boolean;
  productListingView: import("./index").ProductListingView;
  undoBtnContainerStyle: boolean;
}

export default function CartAndQuantity({
  isCompareWithProductBox,
  productListingView,
  undoBtnContainerStyle,
  children,
}: CartAndQuantityProps & { children: React.ReactNode }) {
  return (
    <div
      className={`cartAndQuantity ${
        isCompareWithProductBox && ct("text-left")
      }`}
      style={
        undoBtnContainerStyle && productListingView === "grid"
          ? { marginLeft: "-30px" }
          : {}
      }
    >
      {children}
    </div>
  );
}
